import { addActiveLinkClass, goToPage } from '../../utils';

document.addEventListener('DOMContentLoaded', () => {
  addActiveLinkClass({
    anchorSelector: '.main-footer__menu a',
    replaceLink: 'span',
  });

  addActiveLinkClass({
    anchorSelector: '[data-go-to-page]',
    replaceLink: 'span',
    attribute: 'data-go-to-page',
  });

  goToPage();
});
